import React, { useState } from 'react';
import './FAQ.scss';
import right_caret from '../../../assets/images/right_caret.png';
import down_caret from '../../../assets/images/down_caret.png';

const Item = ({ header, content }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div>
      <div className="item">
        <div
          className={isActive ? 'item-header-bold' : 'item-header-regular'}
          onClick={() => setIsActive(!isActive)}
        >
          <div className="item-header-title">{header}</div>
          <div className="item-header-collapse">
            <img
              src={isActive ? down_caret : right_caret}
              alt="drop down caret"
            ></img>
          </div>
        </div>
      </div>
      <div>{isActive && <div className="item-content">{content}</div>}</div>
    </div>
  );
};

export default Item;
